var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 8.05551C6.33398 7.46606 6.56814 6.90076 6.98494 6.48396C7.40174 6.06716 7.96704 5.83301 8.55648 5.83301H15.7782C16.07 5.83301 16.359 5.89049 16.6287 6.00219C16.8983 6.11388 17.1433 6.27758 17.3497 6.48396C17.5561 6.69034 17.7198 6.93535 17.8315 7.20499C17.9432 7.47464 18.0007 7.76365 18.0007 8.05551V15.2772C18.0007 15.569 17.9432 15.858 17.8315 16.1277C17.7198 16.3973 17.5561 16.6423 17.3497 16.8487C17.1433 17.0551 16.8983 17.2188 16.6287 17.3305C16.359 17.4422 16.07 17.4997 15.7782 17.4997H8.55648C8.26462 17.4997 7.97562 17.4422 7.70597 17.3305C7.43632 17.2188 7.19132 17.0551 6.98494 16.8487C6.77856 16.6423 6.61485 16.3973 6.50316 16.1277C6.39147 15.858 6.33398 15.569 6.33398 15.2772V8.05551Z",
    stroke: "#211D25",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84333 13.9475C3.58779 13.8018 3.37523 13.5912 3.22715 13.3371C3.07906 13.0829 3.00071 12.7942 3 12.5V4.16667C3 3.25 3.75 2.5 4.66667 2.5H13C13.625 2.5 13.965 2.82083 14.25 3.33333",
    stroke: "#211D25",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b1b1104d85c4c33616c6f382fb158c77.svg";
export { ForwardRef as ReactComponent };